import React from "react";
import { useAnimateInView } from "./useAnimateInView";
import BackgroundImage from "../Assets/TotalAutomationsPage/bg.png";
import { formatNumber } from "@SeemplicityDev/shared";
import SeemaMenCount from "../Components/SeemaMenCount";

interface TotalAutomationsPageProps {
  data?: {
    ticketing_automations: {
      total_count: number;
      total_tickets_count: number;
    };
    reporting_automations?: {
      total_count: number;
    };
    total_closed_tickets_count: number;
  };
}

const TotalAutomationsPage: React.FC<TotalAutomationsPageProps> = ({
  data,
}) => {
  const { ref, animateClassNames } = useAnimateInView();
  const {
    ticketing_automations,
    reporting_automations,
    total_closed_tickets_count,
  } = data || {};
  return (
    <div
      className={`eoy-page total-automations-page ${animateClassNames}`}
      ref={ref}
    >
      <img src={BackgroundImage} alt="Background" className="bg-image" />
      <h2 className="page-title">Scaling Remediation with Automations</h2>
      <div className="automations-container">
        <div className="automation-type ticketing-automations-type">
          <span className="automation-type-title">Ticketing Automations</span>
          <div className="automation-type-count">
            {formatNumber(ticketing_automations?.total_count) || 0}{" "}
            <span>queues generated</span>{" "}
            {formatNumber(ticketing_automations?.total_tickets_count) || 0}{" "}
            <span>tickets</span>
          </div>
        </div>
        {!!reporting_automations && (
          <div className="automation-type reporting-automations-type">
            <span className="automation-type-title">Reporting Automations</span>
            <div className="automation-type-count">
              {formatNumber(reporting_automations?.total_count) || 0}{" "}
              <span>configured queues </span>
            </div>
          </div>
        )}
      </div>
      <SeemaMenCount
        textComponent={
          <div className="text-content">
            <span className="subtitle">Did you know?</span>
            {!!total_closed_tickets_count &&
            total_closed_tickets_count > 200 ? (
              <>
                <span className="title">
                  {total_closed_tickets_count
                    ? formatNumber(Math.ceil(total_closed_tickets_count * 0.5))
                    : 0}{" "}
                  Hours
                </span>
                <p className="description">
                  of employees' time <span>was saved{`\n`}</span> by Seemplicity
                  Automations
                </p>
              </>
            ) : (
              <p className="description">
                More Seemplicity Automations{`\n`} can{" "}
                <span>boost efficiency{`\n`}</span>
                and <span>save valuable time</span>
              </p>
            )}
          </div>
        }
        menCount={100}
      />
    </div>
  );
};

export default TotalAutomationsPage;
